export enum IncidentStatusEnum {
  aguard_analise = 'Aguardando Análise',
  aguard_info = 'Aguardando Informações',
  finalized = 'Finalizado',
}
